module.exports = __webpack_public_path__ + "static/media/background-1.f2725f18.svg";